/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class ResourceOperationRegexQueryOperator extends models.QueryOperator {
    constructor() {
        super();
        this.setDiscriminator("ResourceOperationRegexQueryOperator");
    }

    getFixupPrototypeFunction() { return ResourceOperationRegexQueryOperator.fixupPrototype; }

    static newInstance(model: Partial<ResourceOperationRegexQueryOperator>): ResourceOperationRegexQueryOperator {
        let obj = Object.assign(new ResourceOperationRegexQueryOperator(), model);
        ResourceOperationRegexQueryOperator.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<ResourceOperationRegexQueryOperator>): ResourceOperationRegexQueryOperator {
        if (!model) return null;
        return ResourceOperationRegexQueryOperator.newInstance(<ResourceOperationRegexQueryOperator> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: ResourceOperationRegexQueryOperator) {
        if (!obj) return;

        models.ResourceOperationRegexQueryOperator.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: ResourceOperationRegexQueryOperator): boolean {
        if (models.QueryOperator.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, ResourceOperationRegexQueryOperator.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
        if (this.resource_operation) {
            models.Regex.fixupPrototype(this.resource_operation);
        }
    }

    /**
     * Include response that has the given resource_operation pattern
     */
    resource_operation: models.Regex;

}
